import { createMetrics } from 'react-metrics';

import metricsConfig from './config';
import metricsOptions from './options';

export const config = metricsConfig;
export const options = metricsOptions;

export const metrics = createMetrics(config);

export default metrics;
